import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { StepsModule } from 'primeng/steps';
import { TranslateModule } from '@ngx-translate/core';
import { BaseFormViewer, FormCreatorService, FormSectionPageComponent, FormSectionTitleComponent } from 'lib-base';

@Component({
  selector: 'app-form-viewer',
  standalone: true,
  imports: [
    CommonModule, ReactiveFormsModule,
    FormSectionTitleComponent, FormSectionPageComponent,
    ButtonModule, CardModule, StepsModule, TranslateModule
  ],
  templateUrl: './form-viewer.component.html',
  styleUrl: './form-viewer.component.scss'
})
export class FormViewerComponent extends BaseFormViewer {

  constructor(public override fc: FormCreatorService) {
    super(fc);
  }  

  submit() {
    if (!this.onSubmitForm) return;
    //Validate and get the subform values
    let subformInvalid = false;
    this.fc.Form.subForm.forEach((subforms, name) => {
      subforms.forEach(subform => {
        subform.pages.forEach(page => {
          page.submitted = true;
          subformInvalid = !page.formGroup.valid;
        });
      });
    });
    if (subformInvalid) return;
    
    //Validate current form
    this.fc.Pages[this.fc.activeIndex].submitted = true;
    if(!this.fc.pagesFormGroup?.valid) return;

    const formValues = this.fc.Form.getFormValues();
    const dataString = JSON.stringify(formValues)    
    this.onSubmitForm(dataString);
  }

  clearPage() {
    this.fc.clearCurrentPage();
  }
}
